export default __webpack_public_path__ + "static/media/tricko.9defbc40.jpg";